<div class="expandable-column" (click)="toggleExpanded()">
    <div class="expandable-column-content" [class.expanded]="expanded()">
        <ng-content></ng-content>
    </div>
    @if (showIcon()) {
        <mat-icon class="expandable-column-arrow" [ngClass]="{ expanded: expanded() }">expand_more</mat-icon>
    }
</div>
